const images = require.context("./images", true)
const movies = require.context("./movies", true)

let content = {
	name: "सृष्टिको गीत भाग १",
	key: "shristi-ko-geet-part-one",
	coverImage: images("./Coverpage-shristi-ko-fool.png"),
	movie: movies("./Shrishti Ko Geet Part 1 V2.mp4"),
	movies: [],
	timestamps: [],
	subtitles: [],
	content: "",
}

content.timestamps = content.timestamps.map((time) => {
	return { ...time, totalTime: Number(time.min * 60) + Number(time.sec) }
})
content.subtitles = content.subtitles.map((time) => {
	return { ...time, totalTime: Number(time.min * 60) + Number(time.sec) }
})
//
export default content
